import React from 'react'
import PropTypes from 'prop-types'
import {Route} from 'react-router'
import RouterContext from '../../../contexts/RouterContext'

const propTypes = {
  children: PropTypes.any,
}

function RouterProvider({children}) {
  return (
    <Route>
      {router => <RouterContext.Provider value={router}>{children}</RouterContext.Provider>}
    </Route>
  )
}

RouterProvider.propTypes = propTypes

export default RouterProvider
